/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showcase_Viewthread1Inputs */

const zh_showcase_viewthread1 = /** @type {(inputs: Showcase_Viewthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看对话`)
};

const en_showcase_viewthread1 = /** @type {(inputs: Showcase_Viewthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Conversation`)
};

const es_showcase_viewthread1 = /** @type {(inputs: Showcase_Viewthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver conversación`)
};

/**
* | output |
* | --- |
* | "View Conversation" |
*
* @param {Showcase_Viewthread1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const showcase_viewthread1 = /** @type {((inputs?: Showcase_Viewthread1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showcase_Viewthread1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_showcase_viewthread1(inputs)
	if (locale === "en") return en_showcase_viewthread1(inputs)
	return es_showcase_viewthread1(inputs)
});
export { showcase_viewthread1 as "showcase_viewThread" }